import { v4 as uuid } from 'uuid';

const VISITOR_KEY = 'vibe-public-app:visitor-id';
const SESSION_KEY = 'vibe-public-app:session-id';

let memoryVisitorId;
let memorySessionId;

function readWriteId(storageName, key, setMemory, currentMemory) {
  if (typeof window === 'undefined') {
    return currentMemory ?? setMemory(uuid());
  }
  try {
    const store = window[storageName];
    const existing = store.getItem(key);
    if (existing) return existing;
    const next = uuid();
    store.setItem(key, next);
    return next;
  } catch {
    return currentMemory ?? setMemory(uuid());
  }
}

export function getVisitorId() {
  return readWriteId('localStorage', VISITOR_KEY, (v) => (memoryVisitorId = v), memoryVisitorId);
}

export function getSessionId() {
  return readWriteId('sessionStorage', SESSION_KEY, (v) => (memorySessionId = v), memorySessionId);
}
